


















































  import { Vue, Component, Prop } from 'nuxt-property-decorator'
  import uuid from 'uuid-random'
  import { namespace } from 'vuex-class'
  import { Throttle } from '@one/core'
  import { EnsureClientSide } from '~/utils/clientSideDecorator'

  const categories = namespace('categories')

  @Component
  export default class OneCmsCategoriesMegadropdown extends Vue {
    showMegadropdown: boolean = false
    dropdownPosition: any = {}
    currentItem: any = null
    currentUuid: string | null = null
    backdropElement: HTMLElement | null = null
    maxNumberOfSubcategories: number = 7
    lastNonEmptyCompoundPath: Array<EventTarget> = []

    @categories.Getter getCategory: any;

    @Prop({
      type: Array,
      required: false,
    })
    readonly items!: Array<any>;

    @Prop({
      type: String,
      required: false,
    })
    readonly popupParent!: string;

    @Prop({
      type: Boolean,
      default: true,
      required: false,
    })
    readonly showBackdrop!: boolean;

    get popupClasses() {
      return [this.currentUuid, this.hasOnlyEmptySubcategories && 'grid-list-megapopup__popup--only_empty']
    }

    get hasOnlyEmptySubcategories() {
      return this.emptySubcategories.length && !this.nonEmptySubcategories.length
    }

    get emptySubcategories() {
      return this.subcategories(this.currentItem.id).filter((subCatId: string) => !this.subcategories(subCatId).length)
    }

    get nonEmptySubcategories() {
      return this.subcategories(this.currentItem.id).filter((subCatId: string) => this.subcategories(subCatId).length)
    }

    get subcategories() {
      return (categoryId: string) => {
        const category = this.getCategory(categoryId)
        return (category && category.children) || []
      }
    }

    get wrapper(): HTMLElement {
      return this.$refs.wrapper as HTMLElement
    }

    get isItemActive() {
      return (item: any) => {
        return this.currentItem === item
      }
    }

    getPosition(element: HTMLElement) {
      const clientRect: any = element.getBoundingClientRect()
      return {
        left: clientRect.left + document.body.scrollLeft,
        top: clientRect.top + document.body.scrollTop,
        width: element.offsetWidth,
        height: element.offsetHeight,
      }
    }

    beforeDestroy() {
      this.detachMouseMoveWatcher()
      this.removeBackdrop()
    }

    @EnsureClientSide
    attachMouseMoveWatcher() {
      document.addEventListener('mousemove', this.onMouseMoveOverDocument)
    }

    @EnsureClientSide
    detachMouseMoveWatcher() {
      document.removeEventListener('mousemove', this.onMouseMoveOverDocument)
    }

    @Throttle(200)
    checkIfWeShouldHidePopup() {
      const notOnChildrenElement = !this.lastNonEmptyCompoundPath.find(
        (x: HTMLElement | any) =>
          x.className &&
          typeof x.className === 'string' &&
          x.className.includes(this.currentUuid) &&
          x.id !== this.popupParent,
      )
      if (notOnChildrenElement) {
        this.showMegadropdown = false
        this.currentUuid = null
        this.currentItem = null
        this.removeBackdrop()
        this.detachMouseMoveWatcher()
      }
    }

    onMouseMoveOverDocument($event: MouseEvent) {
      const path: Array<EventTarget> = $event.composedPath()
      if (!path.length) {
        return
      } else {
        this.lastNonEmptyCompoundPath = path
      }
      this.checkIfWeShouldHidePopup()
    }

    addBackdrop() {
      if (this.backdropElement) {
        this.removeBackdrop()
      }
      this.backdropElement = document.createElement('div')
      const body = document.querySelector('body')
      if (body) {
        this.backdropElement.className = 'grid-list-megapopup__backdrop'
        body.appendChild(this.backdropElement)
      }
    }

    removeBackdrop() {
      if (this.backdropElement) {
        this.backdropElement.remove()
      }
    }

    onMouseOver(_event: MouseEvent, item: any) {
      const popupStickElement: HTMLElement | null = document.getElementById(this.popupParent) || (this.$refs.wrapper as HTMLElement)?.parentElement
      if (popupStickElement) {
        this.currentItem = item
        this.currentUuid = uuid()
        const popupParentPosition = this.getPosition(popupStickElement)
        this.dropdownPosition = {
          left: `${popupParentPosition.width}px`,
          height: `${popupParentPosition.height}px`,
        }
        this.showMegadropdown = true
        this.attachMouseMoveWatcher()
        this.addBackdrop()
      }
    }
  }
